"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
function List(_a) {
    var items = _a.items, onChange = _a.onChange, type = _a.type, heading = _a.heading;
    return react_1.default.createElement(storybook_1.Cards.Card, { className: 'stoybook-videos-form-playlist' },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, heading),
            react_1.default.createElement("div", { className: 'storybook-videos-form-playlist-list' }, items.map(function (item) {
                var _a = react_1.useState(item.has_video), checked = _a[0], setChecked = _a[1];
                return react_1.default.createElement(storybook_1.Forms.Checkbox, { key: item.id, id: type + "-" + item.id, name: item.name, children: item.label, checked: checked, onChange: function (checked) {
                        setChecked(checked);
                        onChange(checked, item.id);
                    } });
            }))));
}
function FormList(_a) {
    var video = _a.video, route = _a.route, api = _a.api, _b = _a.params, params = _b === void 0 ? {} : _b, onChange = _a.onChange, title = _a.title;
    var records = ra_fetch_1.useApi(api).index(route, __assign(__assign({}, params), { has_video: video.id }))[0];
    function toggle(collection, checked, id) {
        var method = checked ? 'store' : 'delete';
        ra_fetch_1.Fetcher.api(api).records(video[collection])[method](collection + ".videos." + method, {
            id: id,
            video_id: video.id,
            channel_id: video.channel_id
        }).then(function (response) {
            var _a;
            onChange((_a = {}, _a[collection] = response.records, _a));
        });
    }
    if (!records.data.length) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(List, { type: route, heading: title, items: records.data, video: video, onChange: function (checked, id) { return toggle(route, checked, id); } });
}
exports.default = FormList;
